import { PropsWithChildren } from "react";
import { HashedPermission } from "@songtradr-one/shared-common";
import { AppStorage, useAppContext } from "@songtradr-one/shared-frontend";
import { DemoTermsGate } from "./DemoTermsGuard.Parts";

/** Demo orgs' users must pass the demo terms gate; everyone else goes straight through */
export const DemoTermsGuard = ({ children }: PropsWithChildren) => {
  const { user, hasPermission } = useAppContext();

  // Wait for the current org's permissions - after an org switch the previous org's user is kept until they load
  if (!user || user.orgId !== AppStorage.currentOrgId) return null;
  // Root holds every permission, demo included
  if (
    !hasPermission(HashedPermission.DEMO) ||
    hasPermission(HashedPermission.SYSTEM_ROOT)
  )
    return children;

  return <DemoTermsGate>{children}</DemoTermsGate>;
};
